import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { WhatsappVerificationComponent } from 'src/app/components/shared/popups/whatsapp-verification/whatsapp-verification.component';
import { BrowserStorageService } from '../browser-storage/browser-storage.service';
import { CommonService } from '../Common-function/common.service';
import {
  MobileActionWallType,
  VerificationContractService
} from './verification-contract.service';

@Injectable({
  providedIn: 'root'
})
export class MobileVerificationFlowService {
  private isPopupOpen: boolean = false;
  private popupOpenState = new Subject<boolean>();
  popupOpenState$ = this.popupOpenState.asObservable();
  private lastProducerWallHandledAt: number = 0;
  private lastProducerWallType: MobileActionWallType | null = null;
  private readonly producerWallDedupMs = 1500;

  constructor(
    private commonService: CommonService,
    private verificationContract: VerificationContractService,
    private storageService: BrowserStorageService,
    private router: Router
  ) {}

  /**
   * Returns true if the current user is a producer.
   * Producers use KYC/SurePass for mobile verification
   */
  private isProducer(): boolean {
    return this.storageService.getCurrentRoles() === 'producer';
  }

  triggerFromError(
    error: any,
    source: MobileActionWallType,
    closeCurrentPopup: boolean = true
  ): boolean {
    if (!this.verificationContract.isMobileActionWall(error)) {
      return false;
    }

    const wallType =
      this.verificationContract.getMobileActionWallType(error) || source;
    const message = this.verificationContract.extractErrorMessage(error);

    this.openVerificationPopup({ wallType, message }, closeCurrentPopup);
    return true;
  }

  openVerificationPopup(
    data: { wallType: MobileActionWallType; message?: string },
    closeCurrentPopup: boolean = false
  ): boolean {
    if (this.isPopupOpen) {
      return false;
    }

    const openPopup = () => {
      if (this.isPopupOpen) {
        return;
      }

      this.isPopupOpen = true;
      this.popupOpenState.next(true);
      const className = this.commonService.getClassName(
        'ipm-whatsapp-verification-model'
      );
      
      let popupData: any = { ...data };
      if (this.isProducer()) {
        popupData.heading = 'Verify Mobile Number';
        popupData.label = 'Mobile Number';
        popupData.subHeading = 'Enter the OTP sent to your Mobile number';
        popupData.message = this.getProducerWallMessage(data.wallType, data.message || '');
        popupData.verificationMethod = 'surepass';
      }

      this.commonService.openModel(
        WhatsappVerificationComponent,
        popupData,
        className,
        true
      );
      this.registerCloseHook();
    };

    if (closeCurrentPopup) {
      this.commonService.closePopUp();
      setTimeout(() => {
        openPopup();
      }, 120);
    } else {
      openPopup();
    }

    return true;
  }

  private registerCloseHook(): void {
    if (!this.commonService.isMobileDisableClick) {
      this.commonService.modelRef?.afterClosed().subscribe(() => {
        this.isPopupOpen = false;
        this.popupOpenState.next(false);
      });
    } else {
      this.commonService.bottomRef?.afterDismissed().subscribe(() => {
        this.isPopupOpen = false;
        this.popupOpenState.next(false);
      });
    }
  }

  private getProducerWallMessage(
    wallType: MobileActionWallType,
    backendMessage: string
  ): string {
    if (wallType === 'play') {
      return 'You have reached 50 plays. please verify your mobile number to continue.';
    }

    if (wallType === 'download') {
      return 'Please verify your mobile number to continue downloading beats.';
    }

    return backendMessage;
  }
}
